import React, { Fragment } from 'react';
import { connect } from 'react-redux';
// import format      from 'date-fns/format';
// import isEqual     from 'date-fns/isEqual';
// import PicGetRequest  from '../apis/PicGetRequest';
import { ExpansionPanel } from './ExpansionPanel';
import { PicInvitationContribStatusTable } from './PicInvitationContribStatusTable';
import { DropDownMenu } from './menus/DropDownMenu';
import { TextButton } from './buttons/TextButton';


// ***************************************************************************
// Component process
// When component mounts the following occurs:
//   - Make api call to get contributions for event and save in local state
//   - Call function to convert contributions array of objects to an array of an array
//   - This conversion function also copies the quantity needed from cell 1 to cell 4 
//     Cell 1 is used as the original amount needed and Cell 4 keeps track of user input
// In the render():
//   - The Styled Table is displayed dynamically by using contributions saved in local
//     state and getStyledContribTable() function.
// Everytime user changes quantity value the onChange method will: 
//   - update the value in cell 4 of the contributions list in local state.
//   - the render function will re-render table with new value.
// ***************************************************************************

const TopBorder = () => (
    <div className="pic-event-tb"/> 
);

// This a flex table component that takes as props an array of rows (each row has array of column/cells) that 
// allows for a fixed number of columns (eg 3 or 4). Note that the contents of each cell or column in the 
// flex table can be text or jsx. The mapping of the data to the JSX structures is done in the componentDidMount
// lifecycle method.
export class PicInvitationContribStatus extends React.Component { 

    constructor(props) {
        super(props);

        this.state = {
            eventObj: this.props.dataset1 || {},
            headerLabels: ["Item Description", "Qty Needed", "Contributors"],
            formError: ''
        }
    }

    //*************************************************************************
    // Lifecycle methods
    //*************************************************************************

    /* Initialize event info object and contribution list. It does not change so its ok to save in this
       child component  */
    componentDidMount = () => {
        let eventObj        = this.props.dataset1 || {};
        this.setState({eventObj});
    }

    
    //*************************************************************************
    // Event Handlers
    //*************************************************************************
    /* this handler is used by ErrorMessage Component. When user clicks the X
     it clears the formError value and effectively closes the message box */
    clearErrorMessage = () => {
        this.setState({formError: ''})
    }

    /* This is fired when user clicks caret icon on the expansion panel1 */
    handleOnClickForPanel1 = () => {
        this.props.handleOnClickForPanel();
    } 


    /* Calls the parent handler used to raise an error */
    handleRaiseError = (text) => {
        this.props.raiseErrorHandler(text);
    }

    //*************************************************************************
    // Column Header Renderer
    //*************************************************************************

    /* Based on column header, send different classname  */
    getHeaderJsx= (content, classname) => {
        return (
            <div className={`${classname}`}>
                {content}
            </div>
        )
    }

    //*************************************************************************
    // Column Renderers 
    //*************************************************************************

    getTextColumnJsx = (content, justify) => {
        return (
            <div className={`pict-text-preview-column-${justify}`}>
                {content}
            </div>
        )
    }

    getDropDownJsx = (indexValue) => {
        let contributions = this.props.dataset2;
        /* construct dropdown list */
        let contributorList = this.getContributorList(contributions, indexValue);
        let ddlist = contributorList.map((contributor, i) => {
            let name   =  this.truncateLastNameIfTooLong(contributor.name);

            return {
                key: i,
                title: `${name} (${contributor.amount}) ` ,
                selected: false,
                listname: 'contributors'
            }
        })
        
        if (!ddlist || ddlist.length === 0) {
            console.log("CORRECT - THERE IS NO DDLIST")
            ddlist = [{title: "None"}]
        }
        console.log("THIS IS DDLIST IN GET DROPDOWN ", ddlist)

        return (
            <div className="pict-alt-dropdown-column-centerx">
                <DropDownMenu title="Names" list={ddlist} 
                            altHeaderClass="drop-down-header-nb"    /* nb stands for no border */
                            altDDListClass="drop-down-list-alt1"
                            config={{displayHeader: false}} toggleSelected={ () => {;} }
                />
            </div>
        )
    }

    //*************************************************************************
    // Row renderers
    //*************************************************************************

    /* Render Header row for contribution table  (processes each header label) */
    getStyledContribHeader = () => {
        let { headerLabels } = this.state;
        let styledHeader = [];
        headerLabels.forEach((headerLabel, idx) => {
            let classname = "pict-header-label-left";
            if (idx === 0) {classname = "pict-header-label-item"};
            if (idx === 1) {classname = "pict-header-label-needed"};
            if (idx === 2) {classname = "pict-header-label-contrib"};
            let headerJsx = this.getHeaderJsx(headerLabel, classname);
            styledHeader.push(headerJsx)
        })
        return styledHeader;
    }


    /* Render rows for contribution table. Column three intially is the 'Count Me In' button but 
       gets converted to DropDownList when user adds a contribution. This allows them to see the 
       list */
    getStyledContribTable = (contributions) => {

        let styledRows = [];
        /* add the header to styledRows */
        styledRows.push(this.getStyledContribHeader());
        /* add the table entries to the styledRows ; note add a +1 to create offset for header row */
        contributions.forEach((row, i) => {
            let itemDescription = row[0];   /* pull column 0 */
            let neededQuantity  = row[1];   /* pull column 1 */
            // let contribAmount   = row[2];   /* pull column 2 */

            let styledRow = []
            styledRow[0] = this.getTextColumnJsx(itemDescription, "left");     /* replaces first column with jsx */
            styledRow[1] = this.getTextColumnJsx(+neededQuantity, "center");   /* replaces secnd column with jsx, Note + sign is technique for removing leading zero */
            styledRow[2] = this.getDropDownJsx(i);

            styledRows.push(styledRow)
        })
        return styledRows;
    }

    //*************************************************************************
    // Utilities / or Help functions
    //*************************************************************************

    /* function to add text button at the end of dropdown list*/
    getTextButton = (indexValue) => {
        /* construct an array with one item to concat to list */
        let textButtonItem = [{
            key: 9999,
            title: <TextButton text="Remove my name" myclassname="text-button-xxsmall" 
                               onClickHandler={this.deleteContributorFromList.bind(this, indexValue, this.getParticipantEmail())} />
        }]
        return textButtonItem;
    }


    /* The following two methods serve as wrappers that hide the implementation details as 
       as how to get participant name and email. How you get it is based on whether your an authenticated user or 
       participant with a token */
    getParticipantName = () => {
        /* if user is logged in, use the name of the authorized user */
        let participantName = "";
        if (this.props.auth.isAuthenticated) {
            participantName = this.props.auth.user.firstname + ' ' + this.props.auth.user.lastname;
        } else {
            participantName = this.state.eventObj.participantName
        }

        return participantName;
    }

    getParticipantEmail = () => {
        /* if user is logged in, use the email of the authorized user */
        let participantEmail = this.props.auth.user.email || this.state.eventObj.participantEmail || "";

        return participantEmail;
    }

    /* Contributor list   is found as 4th item in table row . Created this help function so that
       in event it moves, I only need to change it one place */
    getContributorList = (contributionList, rowIndex) => {
        return contributionList[rowIndex][4];
    }
    
    truncateLastNameIfTooLong = (name) => {
        let maxLength = 13;
        let fullname = name.split(' ');

        return (name.length > maxLength) ? fullname[0] : name;
    }

    //*************************************************************************
    // Component render method
    //*************************************************************************
    render() {
        let contributions = this.props.dataset2;

        let styledContribTable = this.getStyledContribTable(contributions);

        return (
            <div> 
                 <ExpansionPanel onClickHandler={this.handleOnClickForPanel1} text="Contribution Status" open={this.props.open} />
                 {this.props.open  &&  <PicInvitationContribStatusTable rows={styledContribTable} /> }  
            </div>
        );
    };

    
};

const mapStateToProps = (state) => {
    return {
        auth:  state.auth
    };
};

export default connect(mapStateToProps)(PicInvitationContribStatus);
// export default connect(mapStateToProps, mapDispatchToProps)(PicInvitationPanel1);




// WEBPACK FOOTER //
// ./src/components/PicInvitationContribStatus.js